/** @module module:instantsearch.widgets */

/**
 * @external HTMLElement
 * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement
 */

export { default as clearAll } from '../widgets/clear-all/clear-all.js';
export {
  default as currentRefinedValues,
} from '../widgets/current-refined-values/current-refined-values.js';
export {
  default as hierarchicalMenu,
} from '../widgets/hierarchical-menu/hierarchical-menu.js';
export { default as hits } from '../widgets/hits/hits.js';
export {
  default as hitsPerPageSelector,
} from '../widgets/hits-per-page-selector/hits-per-page-selector.js';
export {
  default as infiniteHits,
} from '../widgets/infinite-hits/infinite-hits.js';
export { default as menu } from '../widgets/menu/menu.js';
export {
  default as refinementList,
} from '../widgets/refinement-list/refinement-list.js';
export {
  default as numericRefinementList,
} from '../widgets/numeric-refinement-list/numeric-refinement-list.js';
export {
  default as numericSelector,
} from '../widgets/numeric-selector/numeric-selector.js';
export { default as pagination } from '../widgets/pagination/pagination.js';
export {
  default as priceRanges,
} from '../widgets/price-ranges/price-ranges.js';
export { default as rangeInput } from '../widgets/range-input/range-input.js';
export { default as searchBox } from '../widgets/search-box/search-box.js';
export {
  default as rangeSlider,
} from '../widgets/range-slider/range-slider.js';
export {
  default as sortBySelector,
} from '../widgets/sort-by-selector/sort-by-selector.js';
export { default as starRating } from '../widgets/star-rating/star-rating.js';
export { default as stats } from '../widgets/stats/stats.js';
export { default as toggle } from '../widgets/toggle/toggle.js';
export { default as analytics } from '../widgets/analytics/analytics.js';
export { default as breadcrumb } from '../widgets/breadcrumb/breadcrumb.js';
export { default as menuSelect } from '../widgets/menu-select/menu-select.js';



// WEBPACK FOOTER //
// ./src/widgets/index.js